import React from 'react';
import PropTypes from 'prop-types';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { allowedMessageMoods } from './_allowedPropTypes';
import { cloneObject } from '../../../common/utils';

const MessageText = ({ translate, attributes: receivedAttributes = {}, mood, text }) => {
  const textClasses = ['system-message-text'];

  if (mood) {
    textClasses.push(`mood-${mood}`);
  }

  const attributes = cloneObject(receivedAttributes, {
    className: textClasses.join(' '),
    title: translate(`text-title-${mood}`, { text })
  });

  return <strong {...attributes}>{text}</strong>;
};

MessageText.propTypes = {
  text: PropTypes.string.isRequired,
  mood: PropTypes.oneOf(allowedMessageMoods),
  attributes: PropTypes.object
};

export default withLocalization(MessageText, 'lists/systemMessages');